import React from "react";
import styles from "./index.module.scss";
const RoommatePreferencePopup: React.FC<{
    roommateName: string;
  onShowMatches: () => void;
  className?: string;
}> = ({ roommateName, onShowMatches }) => {
  return (
    <div className={styles.popup}>
      <div className={styles.labelRow}>
        <span className={styles.dot}></span>
        <p className={styles.label}>Roommate preference</p>
      </div>
      <p className={styles.name}>{roommateName}</p>
      <hr className={styles.divider} />
      <a href="#" className={styles.link}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onShowMatches();
        } }>
        show all matches
      </a>
    </div>
  );
};

export default RoommatePreferencePopup;